import styled from 'styled-components';

import { UlStyled } from 'approot/shared/styles/typography.style';
import { rem } from 'approot/shared/style';

export const ConceptsList = styled(UlStyled)`
  margin-bottom: 0;
`;

export const ConceptsDropdownWrapper = styled.div`
  width: 100%;
  max-width: ${rem(360)};
`;
